'use client';
import { Dispatch, ReactNode, SetStateAction, createContext, useContext, useMemo, useState } from 'react';
import { MedicalUnit } from '@/api/medicalUnits/medicalUnits.types';

type Props = {
  aboutData: MedicalUnit;
  children: ReactNode;
};

type ContextValue = {
  aboutData: MedicalUnit | null;
  setAboutData: Dispatch<SetStateAction<MedicalUnit>>;
};

const AboutDataContext = createContext<ContextValue>({
  aboutData: null,
  setAboutData: () => {},
});

export const AboutDataProvider = ({ aboutData: dataDefault, children }: Props) => {
  const [aboutData, setAboutData] = useState(dataDefault);

  const memoizedValue = useMemo(
    () => ({
      aboutData,
      setAboutData,
    }),
    [aboutData],
  );

  return <AboutDataContext.Provider value={memoizedValue}>{children}</AboutDataContext.Provider>;
};

export const useAboutDataContext = () => useContext(AboutDataContext);
